import { ApolloSandbox } from '@apollo/sandbox';
import { UserManager } from 'oidc-client-ts';

interface Config {
    auth: {
        authority: string;
        client_id: string;
    };
}

const config: Config = await (await fetch('/landing.json')).json();

function getRedirectUri(): string {
    return document.location.href.replace(/#.*/, '');
}

const userManager = new UserManager({
    ...config.auth,
    redirect_uri: getRedirectUri(),
    response_mode: 'fragment',
    automaticSilentRenew: false, // enabled after login has settled
});
userManager.events.addUserLoaded((user) => {
    console.log('user', user);
});

if (new URL(document.location.href).hash.includes('state=')) {
    try {
        await userManager.signinCallback();
    } catch (err) {
        console.warn(err);
        await userManager.clearStaleState();
        await userManager.signinRedirect();
    } finally {
        // hide auth stuff from address bar and history
        window.history.replaceState(null, '', getRedirectUri());
    }
} else {
    await userManager.clearStaleState();
    await userManager.signinRedirect();
}

userManager.startSilentRenew();

new ApolloSandbox({
    target: document.getElementById('apollo-sandbox')!,
    initialEndpoint: `${document.location.origin}/graphql`,
    endpointIsEditable: false,
    runTelemetry: false,
    hideCookieToggle: true,
    initialState: { pollForSchemaUpdates: false },
    async handleRequest(url, options) {
        const user = await userManager.getUser();
        if (!user || user.expired) {
            await userManager.clearStaleState();
            await userManager.signinRedirect();
        }
        return fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                Authorization: `Bearer ${user?.access_token}`,
            },
        });
    },
});
